import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChartContainer } from '@/components/Chart/ChartContainer';
import { MomentumConditionCards } from '@/components/Chart/MomentumConditionCards';
import { useChartStore } from '@/store/chartStore';
import { trackPageView, trackSymbolChange } from '@/services/gtag';
import { useApplySharedChart } from '@/hooks/useApplySharedChart';

export function ChartPage() {
  const { symbol } = useParams<{ symbol: string }>();
  useApplySharedChart();
  const setSymbol   = useChartStore((s) => s.setSymbol);
  const navigate    = useNavigate();
  const prevSymbol  = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (symbol) {
      const upper = symbol.toUpperCase();
      setSymbol(upper);
      trackPageView(upper);
      trackSymbolChange(upper, prevSymbol.current);
      prevSymbol.current = upper;
    } else {
      navigate('/chart/ASI', { replace: true });
    }
  }, [symbol, setSymbol, navigate]);

  return (
    <div className="flex flex-col h-full">
      <MomentumConditionCards />
      <div className="flex-1 min-h-0 relative">
        <ChartContainer />
      </div>
    </div>
  );
}
